import React, { useEffect } from 'react';
import { ParallaxLayer } from '../../../custom_modules/react-spring/src/renderprops/addons/index';
import useOnScreen from '../useOnScreen';
import './EMacroInfluencer.scss';
import macro from '../assetsV2/81.png';
import trophy from '../assetsV2/82.png';
import puzzle from '../assetsV2/83.png';

import anime from 'animejs';



// Little helpers ...

const data = [
  {
    title: 'Macro Influencers',
    desc: 'Harness the power of broad based celebrity association and reach the greatest number of viewers across a wide range of platforms with macro influencers.',
    img: macro,
  },
  {
    title: 'Micro Influencers',
    desc: 'Micro-influencers produce authentic content that audiences love. This leads to successful engagement, yields positive campaign results and maximizes ROI.',
    img: trophy,
    subtext: 'Micro-influencers have 7x more engagement than macro influencers¹',
    link: 'https://influencermarketinghub.com/influencer-marketing-benchmark-report-2020/',
  },
  {
    title: 'Discover the Right Mix of Influencers',
    desc: 'Whether you’re promoting a game or a brand outside of gaming, Noiz.gg helps you team up with the right mix of big and small streamers to reach your audience. With access to tens of thousands of content creators, we make it easy to run campaigns that get attention and deliver results.',
    img: puzzle,
  },
];

const EMacroInfluencer = (props) => {
  const {
    pOffset, layoutFactor = 1, offsetAdjust = 0, navToOffset = () => null, contactNavIndex = 0,
  } = props;
  const ref = React.createRef();

  const onScreen = useOnScreen(ref, '100px', 0.5);
  const [debounce, setDebounce] = React.useState(true);

  useEffect(() => {
    if (onScreen && debounce) {
      anime({
        targets: '.cascade-fade-e',
        opacity: [1, 0],
        translateY: 100,
        duration: 800,
        direction: 'reverse',
        easing: 'linear',
        delay: anime.stagger(60, { direction: 'reverse' }),
      });
      setDebounce(false);
    }
  }, [onScreen, debounce]);

  return (

    <>
      <ParallaxLayer
        offset={pOffset + offsetAdjust}
        factor={layoutFactor}
        speed={0}
        className="slide-e-container"
      >
        <div className='slide-e-container-row'>
          {
            data.map((item, index) => (
              <div>
                <div className="cascade-fade-e brand-image-container">
                  <img className="brand-micro-image" src={item.img} alt={item.title} loading="lazy"/>
                  {item.subtext && (
                    <div className="brand-subtext">
                      {item.subtext}<br/>
                      {item.link && (
                        <a
                          href={item.link}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="brand-subtext-link"
                        >
                          source¹
                        </a>
                      )}
                    </div>
                  )}
                  <div ref={ref} />
                </div>

                <div className="cascade-fade-e brand-info-container">
                  <div className="brand-title" >{item.title}</div>
                  <div className={`grey-brand-body-text${index !== 2 ? ' mt20' : ''}`}>
                    {item.desc}
                  </div>
                </div>
              </div>
            ))}
        </div>
        <button
          onClick={() => navToOffset(contactNavIndex - 1.8)}
          className="brand-white-button"
        >
          Learn More
        </button>
      </ParallaxLayer>


      <ParallaxLayer offset={pOffset + offsetAdjust} factor={layoutFactor} speed={0.8} className="brand-angle-svg" />

    </>

  );
};


export default EMacroInfluencer;

